/* HIKMATI Performance/Zuverlaessigkeit fuer die Produkt-Tabs (featured-tabs). Keine Designaenderung.
   Muss VOR global.js laufen (steht in layout/theme.liquid davor), damit das Theme-Element erweitert werden kann.
   - Erster Tab bereits per Liquid ausgeliefert: kein erneuter Abruf, keine Aus-/Einblend-Animation beim Start.
   - Weitere Tabs: Abruf beim ersten Oeffnen (wie bisher), jetzt mit Fehlerpruefung, 1 automatischem Wiederholen,
     ohne Doppelabruf und ohne dass ein spaet eintreffender Tab den aktiven Tab ueberschreibt. Danach wird der Bereich
     wiederverwendet (wie bisher).
   - Beim Hovern/Fokussieren/Beruehren eines Tabs wird NUR das HTML des Bereichs vorgeholt (keine Bilder). */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  var nativeDefine = customElements.define.bind(customElements);

  function wrapTabs(Base) {
    return class extends Base {
      onTabClickHandler(current) {
        if (!this.__hkInit) {
          this.__hkInit = true;
          var c = this.featured_col_tabs;
          var idx = current && current.getAttribute('data-index');
          var ready = c && idx && c.querySelector('[data-index="' + idx + '"]');
          if (ready) { ready.classList.add('active'); return; }
        }
        return super.onTabClickHandler(current);
      }

      connectedCallback() {
        var self = this;
        if (this.__hkIntent) return;
        this.__hkIntent = true;
        var saveData = navigator.connection && navigator.connection.saveData;
        if (saveData) return;
        var intent = function (e) {
          var t = e.target && e.target.closest ? e.target.closest('.featured-tabs__item') : null;
          if (t) self.__hkPrefetch(t);
        };
        this.addEventListener('pointerenter', intent, true);
        this.addEventListener('focusin', intent);
        this.addEventListener('touchstart', intent, { passive: true });
      }

      __hkUrl(item) {
        return window.routes.collections_url + '/' + item.getAttribute('data-handle') + '?view=' + this.data_ajax +
          '&sort_by=' + (this.settings + item.getAttribute('data-settings'));
      }

      __hkText(url, key) {
        var self = this;
        this.__hkCache = this.__hkCache || {};
        if (this.__hkCache[key]) return this.__hkCache[key];
        var p = fetch(url, { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        });
        this.__hkCache[key] = p;
        p.catch(function () { if (self.__hkCache) delete self.__hkCache[key]; });
        return p;
      }

      __hkPrefetch(item) {
        var idx = item.getAttribute('data-index');
        if (!idx || !this.featured_col_tabs || this.featured_col_tabs.querySelector('[data-index="' + idx + '"]')) return;
        this.__hkText(this.__hkUrl(item), idx).catch(function () {});
      }

      getProducts(handle, dataObj, dataIndex) {
        var self = this, cont = this.featured_col_tabs;
        this.__hkBusy = this.__hkBusy || {};
        if (this.__hkBusy[dataIndex]) return;
        this.__hkBusy[dataIndex] = true;
        var item = this.querySelector('.featured-tabs__item[data-index="' + dataIndex + '"]');
        var prev = null;
        var act = cont.querySelector('.active');
        if (act) prev = this.querySelector('.featured-tabs__item[data-index="' + act.getAttribute('data-index') + '"]');
        var url = window.routes.collections_url + '/' + handle + '?view=' + this.data_ajax + '&sort_by=' + dataObj;

        function attempt(n) {
          return self.__hkText(url, dataIndex).catch(function (err) {
            if (n >= 1) throw err;
            return new Promise(function (r) { setTimeout(r, 900); }).then(function () { return attempt(n + 1); });
          });
        }

        attempt(0).then(function (html) {
          var isCurrent = !item || item.classList.contains('active');
          if (isCurrent) {
            cont.querySelectorAll('.active').forEach(function (el) {
              el.classList.remove('tab__smooth_hide');
              el.classList.remove('active');
            });
          }
          var content = document.createElement('div');
          if (isCurrent) { content.classList.add('active'); content.classList.add('tab__smooth_hide'); }
          content.classList.add('featured-tab-products');
          content.setAttribute('data-handle-loaded', handle);
          content.setAttribute('data-index', dataIndex);
          content.setAttribute('role', 'tabpanel');
          content.innerHTML = html;
          cont.appendChild(content);
          delete self.__hkBusy[dataIndex];
          if (!isCurrent) return;
          setTimeout(function () {
            content.classList.add('tab__smooth_show');
            setTimeout(function () {
              content.classList.remove('tab__smooth_hide');
              content.classList.remove('tab__smooth_show');
              window.dispatchEvent(new CustomEvent('reresizeimage'));
            }, 300);
          }, 10);
        }).catch(function (err) {
          delete self.__hkBusy[dataIndex];
          if (window.console && console.warn) console.warn('HIKMATI: Tab-Inhalt konnte nicht geladen werden', err && err.message);
          // Vorherigen Tab wieder als aktiv markieren, damit Anzeige und Inhalt zusammenpassen; erneutes Anklicken versucht es noch einmal.
          if (item && prev && item !== prev) { item.classList.remove('active'); prev.classList.add('active'); }
        });
      }
    };
  }

  customElements.define = function (name, ctor, options) {
    if (name === 'featured-tabs') { try { ctor = wrapTabs(ctor); } catch (e) { /* Original verwenden */ } }
    return nativeDefine(name, ctor, options);
  };
})();
